<template>
  <div class="content container-fluid">
    <div class="row">
      <div class="col-sm-6"></div>
      <div class="col-sm-6">
        <div class="row" style="margin-top: 1em;">
          <!-- <div class="col-sm-2 col-xs-3 pay_down"></div> -->
          <div class="col-sm-3 col-xs-3 pay_down">
            <p>剩余免费下载次数</p>
            <h6>{{account.freeDownNum}}</h6>
          </div>
          <div class="col-sm-3 col-xs-3 pay_down">
            <p>剩余付费下载次数</p>
            <h6>{{account.payDownNum}}</h6>
          </div>
          <div @click="pricing" class="col-sm-3 col-xs-3 pay_down" style="text-align: center;cursor: pointer;">
            <p style="color: #FF6A6B;">购买下载次数包</p>
            <i style="color: #FF6A6B;font-size:26px" class="iconfont icon-tubiaozhizuomoban" />
          </div>
          <!-- <div v-if="account.isVip==0" @click="pricing" class="col-sm-3 col-xs-3 pay_down" style="text-align: center;cursor: pointer;">
            <p style="color: #ED9F1B;">购买VIP</p>
            <p>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-huangguan-VIP"></use>
              </svg>
            </p>
          </div>
          <div v-else @click="pricing" class="col-sm-3 col-xs-3 pay_down" style="text-align: center;cursor: pointer;">
            <p style="color: #ED9F1B;">{{account.vipExpireTime| formatDate}}</p>
            <p>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-huangguan-VIP"></use>
              </svg>
            </p>
          </div> -->
        </div>
      </div>

      <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12 continfobox" id="list-box-64" data-tags="business">
        <div ref="file_upload" class="uploadbox text-center">
          <div style="margin:1em">
            <span style="line-height: 15em;">
              <i @click="click_upload" class="iconfont icon-shangchuan upload_icon"></i>
            </span>
            <p>拖拽到这里上传</p>
            <p>上传包最大{{_Global.UPLOAD_PKG_SIZE}}</p>
            <input @change="file_change" id="file" type="file" style="display:none" />
          </div>

        </div>
      </div>
      <div v-for="app,index in appList" class="col-lg-2 col-md-3 col-sm-6 col-xs-12 continfobox" id="list-box-64"
        data-tags="business">
        <div class="appbox text-center">
          <div style="margin:1em">
            <img v-if="app.iConData" style="width: 5em;height: 5em;" class="app_logo" :src="app.iConData" />
            <svg v-if="!app.iConData" class="icon app_logo"
              style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="11803">
              <path
                d="M907.82208 1024H116.1728C64.73728 1024 23.04 982.3232 23.04 930.90816v-535.552C115.61984 492.544 236.84096 562.176 373.19168 590.70976c4.67456 72.89344 64.69632 130.7392 138.80832 130.7392 74.10688 0 134.12864-57.85088 138.8032-130.7392C787.15392 562.176 908.38016 492.544 1000.96 395.35616v535.552C1000.96 982.3232 959.26272 1024 907.82208 1024z m-302.68928-442.18368c0 51.40992-41.69728 93.09184-93.1328 93.09184-51.43552 0-93.13792-41.6768-93.13792-93.09184 0-51.41504 41.69728-93.09184 93.13792-93.09184 51.43552 0 93.1328 41.68192 93.1328 93.09184zM512 442.18368c-72.05888 0-130.67776 54.7328-138.20416 124.75392C235.43808 537.03168 113.40288 463.35488 23.04 360.97024v-35.15392c0-51.40992 41.69728-93.09184 93.1328-93.09184h140.8768C268.83584 102.26688 378.40896 0 512 0c133.59104 0 243.16416 102.26688 254.94528 232.7296h140.8768c51.43552 0 93.13792 41.6768 93.13792 93.09184v35.1488c-90.36288 102.38976-212.39808 176.06144-350.76096 205.96736-7.5264-70.02112-66.14528-124.75392-138.19904-124.75392z m0-349.09184c-82.08896 0-149.8112 60.71808-161.13664 139.63776h322.26816C661.8112 153.80992 594.08896 93.09184 512 93.09184z"
                fill="#EA743B" p-id="11804"></path>
            </svg>
            <i v-if="app.mergeIcon" style="margin:1em" class="iconfont icon-hebing"></i>
            <img v-if="app.mergeIcon" class="app_logo" style="width:3em" :src="app.mergeIcon" />

            <div style="margin:1em">
              <div class="app_field" style="text-align: left">
                <i v-if="app.osName=='Android'" class="os_icon iconfont icon-anzhuo"></i>
                <i v-else-if="app.osName=='iOS'" class="os_icon iconfont icon-ios"></i>
                <i v-else class="os_icon iconfont icon-application"></i>
                &nbsp;&nbsp;
                <span style="color:#afafaf">{{app.appName}}</span>
              </div>
              <div v-clipboard:copy="_Global.SHORT_LINK_PREFIX+app.shortLink" v-clipboard:success="copy_success"
                v-clipboard:error="copy_error" class="app_field" style="text-align: left;cursor: pointer;">
                <span class="text-overflow" style="color:#afafaf">短连接：{{shortLinkPrefix+app.shortLink}}</span>
              </div>

              <div class="app_field" style="text-align: left;font-size: 14px">
                <span class="text-overflow" style="color:#afafaf">BundleID: {{app.bundleId}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">最新版本: {{app.appVersion}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">打包类型: 企业版</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">累计下载数: {{app.downNum}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">应用状态: {{app.appStatus==1?"正常":"下架"}}</span>
              </div>
              <div class="app_edit" style="text-align: left;">
                <button @click="app_edit(app.shortLink)" class="btn btn-outline-primary">
                  编辑
                </button>
                <button @click="preview(index)" class="btn btn-outline-primary">
                  预览
                </button>
                <button @click="del_app(app.shortLink)" class="btn btn-outline-primary">
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <uploadWindow v-if="show_upload_modal" :useSuperSign="false" :pkgFile="pkgFile" v-on:showModal="showModal">
    </uploadWindow>
  </div>
</template>

<script>
var self;
import uploadWindow from "./UploadWindow";
export default {
  components: {
    uploadWindow
  },
  mounted: function() {
    self = this;
    this.shortLinkPrefix=window.location.protocol+"//"+window.location.host+"/"
    var token = this.getToken();
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/pkg/list", { authToken: token })
      .then(response => {
        self.respDataHandle(response.body, function(respData) {
          // console.log(respData);
          self.appList = respData;
        });
      });
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/token", { authToken: token })
      .then(response => {
        self.respDataHandle(response.body, function(respData) {
          self.account = respData;
          // if(respData.payDownNum>0&& respData.caStatus!=2){
          //   self.$router.push("/identify")
          // }
          self.$emit("setNoLogin", false);
          self.$emit("setAccount", respData);
        });
      });

    this.$nextTick(() => {
      this.$refs.file_upload.ondragover = e => {
        e.preventDefault();
        e.stopPropagation();
      };
      this.$refs.file_upload.ondragleave = e => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
      };
      this.$refs.file_upload.ondrop = e => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
        self.pkgFile = e.dataTransfer.files[0];
        self.show_upload_modal = true;
      };
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      appList: [],
      show_upload_modal: false,
      pkgInfo: {},
      pkgFile: null,
      account: {},
      shortLinkPrefix:null,
    };
  },
  methods: {
    preview: function(index) {
      var shortLink =
        this._Global.SHORT_LINK_PREFIX + this.appList[index].shortLink;
      window.open(shortLink);
    },
    del_app: function(shortLink) {
      this.delete_app(shortLink, function() {
        window.location.reload();
      });
    },
    app_edit: function(shortLink) {
      this.$router.push("/apps/" + shortLink);
    },
    copy_success: function() {
      this.$message({
        message: "复制成功",
        type: "success"
      });
    },
    copy_error: function(e) {
      this.$message.error('Failed to copy texts');
    },
    click_upload: function() {
      $("#file").click();
    },
    file_change: function(event) {
      console.log("读取文件");
      self.pkgFile = event.target.files[0];
      this.show_upload_modal = true;
    },
    showModal: function(show_upload_modal) {
      this.show_upload_modal = show_upload_modal;
    },
    pricing: function() {
      this.$alert('请联系上级代理进行购买', '提示', {
          confirmButtonText: '确定',
        });
      // this.$router.push("/pricing");
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      return y + "-" + MM + "-" + d;
    }
  }
};
</script>

<style scoped>
.pay_down {
  text-align: center;
}

.pay_down p {
  padding: 0;
  color: #afafaf;
}

.pay_down h6 {
  padding: 0;
  margin: 0.4em;
}

.continfobox {
  position: relative;
  margin: 0.3em 3em 3em 3em;
}

.appbox {
  background-color: #fff;
  border-radius: 1em;
  position: relative;
  min-height: 25em;
  width: 22em;
  box-sizing: border-box;
  color: #707070;
  height: 100%;
}

.uploadbox {
  background-color: #46ccfc;
  border-radius: 1em;
  position: relative;
  min-height: 25em;
  width: 22em;
  box-sizing: border-box;
  color: white;
  height: 100%;
}

.upload_icon {
  font-size: 100px;
}

.app_logo {
  width: 6em;
  margin-top: 1em;
  border-radius: 1em;
}

.app_edit {
  padding: 0;
}

.app_edit button {
  margin-left: 0.4em;
}

button {
  width: 4.5em;
  border-radius: 10em;
}
.os_icon {
  font-size: 28px;
}
.continfobox {
  margin: 0 5em 3em 4.6em;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Apps.vue